module.exports = __webpack_public_path__ + "image/news_list_img2.jpg";